var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticStyle: { height: "100%" } },
    [
      _c("zkThreeRow", [
        _c(
          "div",
          {
            staticClass: "company_cla",
            attrs: { slot: "search" },
            slot: "search"
          },
          [
            _c(
              "el-form",
              { attrs: { model: _vm.searchForm, inline: true } },
              [
                _c(
                  "el-form-item",
                  { attrs: { label: "" } },
                  [
                    _c(
                      "el-select",
                      {
                        attrs: { clearable: "" },
                        model: {
                          value: _vm.searchForm.type,
                          callback: function($$v) {
                            _vm.$set(_vm.searchForm, "type", $$v)
                          },
                          expression: "searchForm.type"
                        }
                      },
                      _vm._l(_vm.selectOptions, function(item, index) {
                        return _c("el-option", {
                          key: index,
                          attrs: { label: item.label, value: item.key }
                        })
                      }),
                      1
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "el-form-item",
                  { attrs: { label: "" } },
                  [
                    _c(
                      "el-input",
                      {
                        attrs: {
                          placeholder: this.$t("common.searchValue"),
                          clearable: ""
                        },
                        model: {
                          value: _vm.searchForm.value,
                          callback: function($$v) {
                            _vm.$set(_vm.searchForm, "value", $$v)
                          },
                          expression: "searchForm.value"
                        }
                      },
                      [
                        _c("el-button", {
                          attrs: { slot: "append", icon: "el-icon-search" },
                          on: {
                            click: function($event) {
                              $event.stopPropagation()
                              return _vm.searchFn($event)
                            }
                          },
                          slot: "append"
                        })
                      ],
                      1
                    )
                  ],
                  1
                )
              ],
              1
            ),
            _vm._v(" "),
            _c("ZkButtonGroup", {
              attrs: {
                isLoadGroupName: true,
                groupName: "addCompany",
                isGroup: true
              },
              on: { addCompany: _vm.addCompany }
            })
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { attrs: { slot: "table" }, slot: "table" },
          [
            _c("companyList", {
              ref: "companyList",
              on: { selectRow: _vm.selectRow, searchFn: _vm.searchFn }
            })
          ],
          1
        )
      ]),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            title: this.$t("header.createCompany"),
            visible: _vm.addComVisible,
            width: "45%",
            "append-to-body": ""
          },
          on: {
            "update:visible": function($event) {
              _vm.addComVisible = $event
            },
            close: _vm.handleAddClose
          }
        },
        [
          _c(
            "el-form",
            {
              ref: "createForm",
              attrs: {
                model: _vm.ruleForm,
                rules: _vm.rules,
                "label-width": "180px"
              }
            },
            [
              !_vm.createCmpSuccess
                ? [
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: this.$t("developer.name"),
                          prop: "appKey"
                        }
                      },
                      [
                        _c(
                          "el-select",
                          {
                            staticStyle: { width: "100%" },
                            model: {
                              value: _vm.ruleForm.appKey,
                              callback: function($$v) {
                                _vm.$set(_vm.ruleForm, "appKey", $$v)
                              },
                              expression: "ruleForm.appKey"
                            }
                          },
                          _vm._l(_vm.options, function(item) {
                            return _c("el-option", {
                              key: item.appKey,
                              attrs: { label: item.name, value: item.appKey }
                            })
                          }),
                          1
                        )
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: this.$t("header.companyCode"),
                          prop: "companyCode"
                        }
                      },
                      [
                        _c("el-input", {
                          model: {
                            value: _vm.ruleForm.companyCode,
                            callback: function($$v) {
                              _vm.$set(
                                _vm.ruleForm,
                                "companyCode",
                                typeof $$v === "string" ? $$v.trim() : $$v
                              )
                            },
                            expression: "ruleForm.companyCode"
                          }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: this.$t("header.companyName"),
                          prop: "companyName"
                        }
                      },
                      [
                        _c("el-input", {
                          model: {
                            value: _vm.ruleForm.companyName,
                            callback: function($$v) {
                              _vm.$set(
                                _vm.ruleForm,
                                "companyName",
                                typeof $$v === "string" ? $$v.trim() : $$v
                              )
                            },
                            expression: "ruleForm.companyName"
                          }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "el-form-item",
                      {
                        attrs: { label: this.$t("user.email"), prop: "email" }
                      },
                      [
                        _c("el-input", {
                          model: {
                            value: _vm.ruleForm.email,
                            callback: function($$v) {
                              _vm.$set(
                                _vm.ruleForm,
                                "email",
                                typeof $$v === "string" ? $$v.trim() : $$v
                              )
                            },
                            expression: "ruleForm.email"
                          }
                        })
                      ],
                      1
                    )
                  ]
                : [
                    _c("p", [
                      _vm._v(_vm._s(_vm.$t("developer.createAppSucess")))
                    ]),
                    _vm._v(" "),
                    _c(
                      "el-row",
                      {
                        staticStyle: { margin: "5px 0" },
                        attrs: { gutter: 10 }
                      },
                      [
                        _c("el-col", { attrs: { span: 4 } }, [
                          _vm._v(_vm._s(_vm.$t("apiLog.companyUser")) + "：")
                        ]),
                        _vm._v(" "),
                        _c("el-col", { attrs: { span: 12 } }, [
                          _c(
                            "div",
                            {
                              staticStyle: {
                                display: "flex",
                                "align-items": "center"
                              }
                            },
                            [
                              _c("el-input", {
                                attrs: { disabled: "" },
                                model: {
                                  value: _vm.apiUser.userName,
                                  callback: function($$v) {
                                    _vm.$set(_vm.apiUser, "userName", $$v)
                                  },
                                  expression: "apiUser.userName"
                                }
                              }),
                              _vm._v(" "),
                              _c(
                                "el-tooltip",
                                {
                                  staticClass: "item",
                                  attrs: {
                                    effect: "dark",
                                    content: _vm.$t("company.apiUserTips"),
                                    placement: "bottom"
                                  }
                                },
                                [
                                  _c("i", {
                                    staticClass: "el-icon-info",
                                    staticStyle: { margin: "0 15px" }
                                  })
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "el-button",
                                {
                                  staticClass: "logocontent",
                                  staticStyle: { color: "#4db22f" },
                                  attrs: {
                                    type: "text",
                                    "data-clipboard-text": _vm.apiUser.userName
                                  },
                                  on: {
                                    click: function($event) {
                                      return _vm.copy(".logocontent")
                                    }
                                  }
                                },
                                [
                                  _vm._v(
                                    "\n                " +
                                      _vm._s(_vm.$t("apiLog.copy")) +
                                      "\n              "
                                  )
                                ]
                              )
                            ],
                            1
                          )
                        ])
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "el-row",
                      {
                        staticStyle: { margin: "5px 0" },
                        attrs: { gutter: 10 }
                      },
                      [
                        _c("el-col", { attrs: { span: 4 } }, [
                          _vm._v(_vm._s(_vm.$t("login.password")) + "：")
                        ]),
                        _vm._v(" "),
                        _c("el-col", { attrs: { span: 12 } }, [
                          _c(
                            "div",
                            {
                              staticStyle: {
                                display: "flex",
                                "align-items": "center"
                              }
                            },
                            [
                              _c("el-input", {
                                attrs: { disabled: true },
                                model: {
                                  value: _vm.apiUser.password,
                                  callback: function($$v) {
                                    _vm.$set(_vm.apiUser, "password", $$v)
                                  },
                                  expression: "apiUser.password"
                                }
                              }),
                              _vm._v(" "),
                              _c(
                                "el-tooltip",
                                {
                                  staticClass: "item",
                                  attrs: {
                                    effect: "dark",
                                    content: _vm.$t("company.loginUserTips"),
                                    placement: "bottom"
                                  }
                                },
                                [
                                  _c("i", {
                                    staticClass: "el-icon-info",
                                    staticStyle: { margin: "0 15px" }
                                  })
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "el-button",
                                {
                                  staticClass: "logocontent",
                                  staticStyle: { color: "#4db22f" },
                                  attrs: {
                                    type: "text",
                                    "data-clipboard-text": _vm.apiUser.password
                                  },
                                  on: {
                                    click: function($event) {
                                      return _vm.copy(".logocontent")
                                    }
                                  }
                                },
                                [
                                  _vm._v(
                                    "\n                " +
                                      _vm._s(_vm.$t("apiLog.copy")) +
                                      "\n              "
                                  )
                                ]
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c("div", [_vm._v("此密码只显示一次，请记住密码")])
                        ])
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _vm.companyManagerOn
                      ? [
                          _c(
                            "el-row",
                            {
                              staticStyle: { margin: "5px 0" },
                              attrs: { gutter: 10 }
                            },
                            [
                              _c("el-col", { attrs: { span: 4 } }, [
                                _vm._v(
                                  _vm._s(_vm.$t("user.accountByLogin")) + "："
                                )
                              ]),
                              _vm._v(" "),
                              _c("el-col", { attrs: { span: 12 } }, [
                                _c(
                                  "div",
                                  {
                                    staticStyle: {
                                      display: "flex",
                                      "align-items": "center"
                                    }
                                  },
                                  [
                                    _c("el-input", {
                                      attrs: { disabled: "" },
                                      model: {
                                        value: _vm.superUser.userName,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.superUser,
                                            "userName",
                                            $$v
                                          )
                                        },
                                        expression: "superUser.userName"
                                      }
                                    }),
                                    _vm._v(" "),
                                    _c(
                                      "el-tooltip",
                                      {
                                        staticClass: "item",
                                        attrs: {
                                          effect: "dark",
                                          content: "企业管理员登录该平台的账号",
                                          placement: "bottom"
                                        }
                                      },
                                      [
                                        _c("i", {
                                          staticClass: "el-icon-info",
                                          staticStyle: { margin: "0 15px" }
                                        })
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "el-button",
                                      {
                                        staticClass: "logocontent",
                                        staticStyle: { color: "#4db22f" },
                                        attrs: {
                                          type: "text",
                                          "data-clipboard-text":
                                            _vm.superUser.userName
                                        },
                                        on: {
                                          click: function($event) {
                                            return _vm.copy(".logocontent")
                                          }
                                        }
                                      },
                                      [
                                        _vm._v(
                                          "\n                  " +
                                            _vm._s(_vm.$t("apiLog.copy")) +
                                            "\n                "
                                        )
                                      ]
                                    )
                                  ],
                                  1
                                )
                              ])
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "el-row",
                            {
                              staticStyle: { margin: "5px 0" },
                              attrs: { gutter: 10 }
                            },
                            [
                              _c("el-col", { attrs: { span: 4 } }, [
                                _vm._v(_vm._s(_vm.$t("login.password")) + "：")
                              ]),
                              _vm._v(" "),
                              _c("el-col", { attrs: { span: 12 } }, [
                                _c(
                                  "div",
                                  {
                                    staticStyle: {
                                      display: "flex",
                                      "align-items": "center"
                                    }
                                  },
                                  [
                                    _c("el-input", {
                                      attrs: { disabled: "" },
                                      model: {
                                        value: _vm.superUser.password,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.superUser,
                                            "password",
                                            $$v
                                          )
                                        },
                                        expression: "superUser.password"
                                      }
                                    }),
                                    _vm._v(" "),
                                    _c(
                                      "el-tooltip",
                                      {
                                        staticClass: "item",
                                        attrs: {
                                          effect: "dark",
                                          content: "企业管理员登录该平台的密码",
                                          placement: "bottom"
                                        }
                                      },
                                      [
                                        _c("i", {
                                          staticClass: "el-icon-info",
                                          staticStyle: { margin: "0 15px" }
                                        })
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "el-button",
                                      {
                                        staticClass: "logocontent",
                                        staticStyle: { color: "#4db22f" },
                                        attrs: {
                                          type: "text",
                                          "data-clipboard-text":
                                            _vm.superUser.password
                                        },
                                        on: {
                                          click: function($event) {
                                            return _vm.copy(".logocontent")
                                          }
                                        }
                                      },
                                      [
                                        _vm._v(
                                          "\n                  " +
                                            _vm._s(_vm.$t("apiLog.copy")) +
                                            "\n                "
                                        )
                                      ]
                                    )
                                  ],
                                  1
                                )
                              ])
                            ],
                            1
                          )
                        ]
                      : _vm._e()
                  ]
            ],
            2
          ),
          _vm._v(" "),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer"
            },
            [
              _c("el-button", { on: { click: _vm.handleAddClose } }, [
                _vm._v(
                  _vm._s(
                    _vm.createCmpSuccess
                      ? _vm.$t("developer.isOk")
                      : _vm.$t("common.cancel")
                  )
                )
              ]),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: { click: _vm.sumbitAddCompany }
                },
                [
                  _vm._v(
                    "\n        " +
                      _vm._s(
                        _vm.createCmpSuccess
                          ? _vm.$t("company.entryCompany")
                          : _vm.$t("common.confirm")
                      ) +
                      "\n      "
                  )
                ]
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-0c27d4a4", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0c27d4a4","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/modules/tenantManager/CompanyInfo.vue
// module id = null
// module chunks = 